import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Row,
  Col,
  Select,
  Typography,
  Divider,
} from "antd";
import { DeleteFilled } from "@ant-design/icons";
import { BiBook } from "react-icons/bi";
const { Text } = Typography;
const { Option } = Select;
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  type,
  defaultValue,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  useEffect(() => {
    if (type === "price") {
      form.setFieldsValue({
        priceOnly: record[dataIndex]?.[1],
      });
      form.setFieldsValue({
        Price: record[dataIndex],
      });
      return;
    }
    if (type === "csv") {
      if (record[dataIndex]) {
        form.setFieldsValue({
          [dataIndex]:
            typeof record[dataIndex] === "string"
              ? record[dataIndex].split(",")
              : record[dataIndex],
        });
        return;
      } else {
        form.setFieldsValue({
          [dataIndex]: [],
        });
        return;
      }
    }

    form.setFieldsValue({
      [dataIndex]: record?.[dataIndex],
    });
  }, [dataIndex, record, type, form]);

  const toggleEdit = () => {
    setEditing(!editing);

    if (type === "price") {
      form.setFieldsValue({
        priceOnly: record[dataIndex]?.[1],
      });
      form.setFieldsValue({
        Price: record[dataIndex],
      });
      return;
    } else if (type === "csv") {
      if (record[dataIndex]) {
        form.setFieldsValue({
          [dataIndex]:
            typeof record[dataIndex] === "string"
              ? record[dataIndex].split(",")
              : record[dataIndex],
        });
        return;
      } else {
        form.setFieldsValue({
          [dataIndex]: [],
        });
        return;
      }
    }
  };

  const saveComposite = async (value, key) => {
    try {
      const values = await form.validateFields();
      if (type === "size") {
        let currentValues = record[dataIndex] || [null, null, null, null, null];

        const keyMap = {
          length: 1,
          width: 2,
          height: 3,
        };
        currentValues[keyMap[key]] = value;
        currentValues[0] = getCompositeValue(currentValues);

        form.setFieldsValue({
          [dataIndex]: currentValues,
          [dataIndex + ":length"]: currentValues?.[1],
          [dataIndex + ":width"]: currentValues?.[2],
          [dataIndex + ":height"]: currentValues?.[3],
        });

        record[dataIndex] = currentValues;
        handleSave({ ...record, dataIndex: currentValues });
        // patchAndPostAttributes();
      }
    } catch (e) {}
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      if (type === "price") {
        const price = form.getFieldValue("Price");
        price[1] = values.priceOnly;

        form.setFieldsValue({
          Price: price,
        });
      }
      handleSave({ ...record, ...values }, dataIndex, type);
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  const getCompositeValue = (values) => {
    const dimensionMap = {
      length: "L",
      width: "B",
      height: "H",
    };
    let size = {
      length: values[1],
      width: values[2],
      height: values[3],
    };

    let unit = values[4] || "";

    const { length = "", width = "", height = "" } = size;
    let sizeKeys = Object.keys(size);
    const validSizes = [length, width, height].filter(Boolean) || [];
    const validKeys = sizeKeys.filter((item) => size[item] && item !== "unit");
    const dimensions = validKeys.map((item) => dimensionMap[item]) || [];

    return `${validSizes.join("x")} ${unit}`;
  };

  const renderFields = (type) => {
    const componentsObj = {
      text: <Input ref={inputRef} onBlur={save} onPressEnter={save} />,
      csv: (
        <Select
          mode="tags"
          ref={inputRef}
          onBlur={save}
          onPressEnter={save}
          //   onChange={save}
          notFoundContent={<Text type="secondary">Start typing to add...</Text>}
        >
          {defaultValue?.csv?.map(
            (item, index) =>
              item && (
                <Option key={`${index}${item}`} value={item}>
                  {item}
                </Option>
              )
          )}
        </Select>
      ),
      size: (
        <Row style={{ minWidth: 300, marginTop: "25px" }}>
          <Col span="7">
            <Form.Item name={dataIndex + ":length"}>
              <Input
                style={{
                  borderRadius: "0",
                  borderRight: "none",
                }}
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "length")}
                name=""
                onPressEnter={(e) => saveComposite(e.target.value, "length")}
                size="medium"
                ref={inputRef}
                type="number"
                defaultValue={children?.[1]?.[1]}
              />
            </Form.Item>
          </Col>
          <Col span="7">
            <Form.Item name={dataIndex + ":width"}>
              <Input
                style={{
                  borderRadius: "0",
                  borderRight: "none",
                }}
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "width")}
                onPressEnter={(e) => saveComposite(e.target.value, "width")}
                size="medium"
                ref={inputRef}
                type="number"
                defaultValue={children?.[1]?.[2]}
              />
            </Form.Item>
          </Col>
          <Col span="10">
            <Form.Item name={dataIndex + ":height"}>
              <Input
                className="size_height"
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "height")}
                onPressEnter={(e) => saveComposite(e.target.value, "height")}
                size="medium"
                // ref={inputRef}
                addonAfter={
                  <div
                    style={{ borderRadius: "0", width: "10%" }}
                    ref={inputRef}
                  >
                    {children?.[1]?.[4]}
                  </div>
                }
                type="number"
                defaultValue={children?.[1]?.[3]}
              />
            </Form.Item>
          </Col>
        </Row>
      ),
      price: (
        <Input
          onWheel={(e) => e.currentTarget.blur()}
          onBlur={save}
          onPressEnter={save}
          size="large"
          ref={inputRef}
          style={{ minWidth: 300 }}
          addonBefore={<div ref={inputRef}>{children?.[1]?.[0]}</div>}
          addonAfter={<div ref={inputRef}>{children?.[1]?.[2]}</div>}
          type="number"
          // defaultValue={children?.[1]}
        />
      ),
      textarea: (
        <Input.TextArea ref={inputRef} onBlur={save} onPressEnter={save} />
      ),
      select: (
        <Select size="large" ref={inputRef} onChange={save}>
          {defaultValue && defaultValue?.select?.length > 0
            ? defaultValue?.select?.map((item, index) => (
                <Option key={`${index}${item}`} value={item}>
                  {item}{" "}
                </Option>
              ))
            : null}
        </Select>
      ),
    };
    return (
      componentsObj[type] || (
        <Input ref={inputRef} onBlur={save} onPressEnter={save} />
      )
    );
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={type === "price" ? "priceOnly" : dataIndex}
      >
        {renderFields(type)}
      </Form.Item>
    ) : (
      <Form.Item
        style={{
          margin: 0,
        }}
        onClick={toggleEdit}
        name={type === "price" ? "priceOnly" : dataIndex}
      >
        {renderFields(type)}
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

export default class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      count: 1,
      payload: [],
      currency: "USD",
      unit: "per-piece",
    };
  }

  
  static = [
    {
      title: "Delete",
      dataIndex: "delete",
      render: (_, record) =>
        this.props.dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => this.handleDelete(record.key)}
          >
            <DeleteFilled style={{ color: "#CDCFCE" }} />
          </Popconfirm>
        ) : null,
      width: "10%",
    },
    {
      title: "Variant ID",
      dataIndex: "variantId",
      editable: true,
      width: "22%",
    },
  ];

  

  componentDidMount() {

    if (this.props.variantsData.length > 0) {
      this.createColumns(this.props.variantsData?.[0].attributes || this.props.variantsData?.[0]);
      this.mapData(this.props.variantsData);
      this.setState({ count: this.props.variantsData.length });
    } else {
      if (this.props.variant && this.props.variant.length > 0) {
        this.createColumns(this.props.variant);
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.variant !== this.props.variant) {
      if (this.props.variant && this.props.variant.length > 0) {
        this.createColumns(this.props.variant);
      }
    }
    if (prevProps.variantsData !== this.props.variantsData) {
      if (this.props.variantsData?.[0].attributes || this.props.variantsData?.[0]) {
        this.createColumns(this.props.variantsData?.[0].attributes || this.props.variantsData?.[0]);
        this.mapData(this.props.variantsData);
        this.setState({ count: this.props.variantsData.length });
      }
    }
  }

  getTableHeader = (dType, variantObj) => {
    switch (dType) {
      case "price":
        return variantObj?.is_internal === false ? (
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              justifyItems: "center",
            }}
          >
            <select
              style={{
                background: "transparent",
                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
              }}
              // value={this.state.currency}
              onChange={(e) =>
                this.handleCurrencyChange(e, variantObj?.name, variantObj?.id)
              }
            >
              <option disabled>Currency</option>
              {variantObj?.default?.currency.map((curr, index) => (
                <option key={index} value={curr}>
                  {curr}
                </option>
              ))}
            </select>
            <span>{variantObj?.name}</span>
            <select
              style={{
                background: "transparent",

                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
              }}
              // value={this.state.unit}
              onChange={(e) =>
                this.handleUnitChange(e, variantObj?.name, variantObj?.id)
              }
            >
              <option disabled>Unit</option>
              {variantObj?.default?.unit.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </span>
        ) : (
          <span>{variantObj?.name}</span>
        );
      case "size":
        return variantObj?.is_internal === false ? (
          <span
            style={{
              color: "#828786",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              justifyItems: "center",
            }}
          >
            <span>{variantObj?.name}</span>
            <select
              style={{
                background: "transparent",
                marginRight: 4,
                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
                minWidth: 100,
                padding: "0px 10px",
              }}
              onChange={(e) => {
                this.handleSizeUnitChange(e, variantObj?.name, variantObj?.id);
              }}
            >
              <option disabled selected value>
                Unit
              </option>
              {variantObj?.default?.unit.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </span>
        ) : (
          <span style={{ color: "#828786" }}>{variantObj?.name}</span>
        );
      default:
        return <span style={{ color: "#828786" }}>{variantObj?.name}</span>;
    }
  };

  mapData = (data) => {
    let dataArray = [];
    data.forEach((item, index) => {
      const attrs = item?.attributes;


      let obj = attrs.map((attr) => {
        const key = `${attr?.attribute_values_id?.attribute_id?.name || attr?.name}:${attr?.attribute_values_id?.attribute_id?.id || attr?.id}`;
        const dType = attr?.attribute_values_id?.attribute_id?.dtype || attr?.dtype;
        const value =
          dType === "price"
            ? [
                attr?.attribute_values_id?.composite?.currency || attr?.composite?.currency,
                attr?.attribute_values_id?.values || attr?.values,
                attr?.attribute_values_id?.composite?.unit || attr?.composite?.unit,
              ]
            : dType === "size"
            ? [
                attr?.attribute_values_id?.values || attr?.values,
                attr?.attribute_values_id?.composite?.length || attr?.composite?.length,
                attr?.attribute_values_id?.composite?.width || attr?.composite?.width,
                attr?.attribute_values_id?.composite?.height || attr?.composite?.height,
                attr?.attribute_values_id?.composite?.unit || attr?.composite?.unit,
              ]
            : attr?.attribute_values_id?.values || attr?.values;
        return {
          [key]: value,
          key: index,
        };
      });

      const keys = Object.assign(...obj);
      dataArray.push({ variantId: item?.variant_id, ...keys });
    });
    this.props.setDataSource(dataArray);
  };
  createColumns = (data) => {
    if (data?.length > 0) {
      const variantCols = data.map((variant, index) => {
        let variantObj = variant?.attribute_values_id?.attribute_id || variant
          ? variant?.attribute_values_id?.attribute_id || variant
          : variant?.attributes_id || variant;

        let columnData = {
          title: this.getTableHeader(variantObj?.dtype, variantObj),
          dataIndex: `${variantObj?.name}:${variantObj?.id}`,
          editable: true,
          type: variantObj?.dtype,
          defaultValue: variantObj?.default,
          width: "20%",
        };
        return columnData;
      });

      const oldIndex = variantCols.findIndex((i) => i.type === "price");
      const newIndex = variantCols.length - 1;
      function arraymove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
        return arr;
      }

      const sorted = arraymove(variantCols, oldIndex, newIndex);

      this.setState({
        columns: [...this.static, ...sorted],
      });
    }
  };

  handleDelete = (key) => {
    const dataSource = [...this.props.dataSource];
    this.props.setDataSource(dataSource.filter((item) => item.key !== key));
  };
  handleAdd = () => {
    const { count } = this.state;
    const { dataSource } = this.props;
    const priceAttr = this.props.priceAttrs?.[0]?.attributes_id || this.props.priceAttrs?.[0];

    const newData = {
      key: count + 1,
      [`${priceAttr?.name}:${priceAttr?.id}`]: [
        this.props.currency,
        "",
        this.props.unit,
      ],
    };
    this.setState({
      count: count + 1,
    });
    this.props.setDataSource([...dataSource, newData]);
  };
  handleSave = (row, dataIndex, type) => {
    const newData = [...this.props.dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];

    newData.splice(index, 1, { ...item, ...row });
    this.props.setDataSource(newData);
  };
  handleCurrencyChange = (event, title, attributeId) => {
    this.setState({
      currency: event?.target?.value,
    });
    this.props.setCurrency(event?.target?.value);
    this.props.setDataSource(
      this.props.dataSource.map((item) => {
        item[`${title}:${attributeId}`]?.length > 0
          ? (item[`${title}:${attributeId}`][0] = event?.target?.value)
          : (item[`${title}:${attributeId}`] = [event?.target?.value]);
        return item;
      })
    );
  };

  handleSizeUnitChange = (event, title, attributeId) => {
    this.setState({ sizeUnit: event?.target?.value });
    this.props.setSizeUnit(event?.target?.value);
    this.props.setDataSource(
      this.props.dataSource.map((item) => {
        if (item[`${title}:${attributeId}`]?.length > 0) {
          item[`${title}:${attributeId}`][4] = event?.target?.value;
          let newValue = this.getCompositeValue(
            item[`${title}:${attributeId}`],
            item[`${title}:${attributeId}`]?.[4]
          );
          item[`${title}:${attributeId}`][0] = newValue;
        } else {
          item[`${title}:${attributeId}`] = [
            null,
            null,
            null,
            null,
            event?.target?.value,
          ];
        }

        return item;
      })
    );
  };

  getCompositeValue = (dimensions, unit) => {
    return `${[dimensions[1], dimensions[2], dimensions[3]]
      .filter(Boolean)
      .join("x")}${unit ? " " + unit : ""}`;
  };
  handleUnitChange = (event, title, attributeId) => {
    this.setState({ unit: event?.target?.value });
    this.props.setUnit(event?.target?.value);
    this.props.setDataSource(
      this.props.dataSource.map((item) => {
        item[`${title}:${attributeId}`]?.length > 0
          ? (item[`${title}:${attributeId}`][2] = event?.target?.value)
          : (item[`${title}:${attributeId}`] = [
              null,
              null,
              event?.target?.value,
            ]);
        return item;
      })
    );
  };
  render() {
    const { dataSource } = this.props;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.state.columns.map((col) => {
      if (!col?.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          type: col.type,
          defaultValue: col.defaultValue,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <div>
        <Row>
          <Col span={24}>
            <Table
              components={components}
              rowClassName={() => "editable-row"}
              bordered
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              // style={{height:400,overflowX:'scroll'}}
              // scroll={{x:'auto',y:'auto'}}
              // sticky
            />
          </Col>
        </Row>
        <Divider />
        <Row style={{ marginTop: "1em" }}>
          <Col>
            <Button onClick={this.handleAdd} type="default">
              + Add a row
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
